// extracted by mini-css-extract-plugin
export default {"mineOwnerMenu":"styles_mineOwnerMenu__vrPDM"};